import { Button, Input, Switch } from "antd";
import { TableProps } from "antd/es/table";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import ListIcon from "../../../assets/icons/ListIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SortIcon from "../../../assets/icons/SortIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import FeaturesView from "../../../components/Package/FeaturesView";
import ManagePackage from "../../../components/Package/ManagePackage";
import CustomTable from "../../../components/ui/CustomTable";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";

export default function Packages() {
  const { open, handleClose, handleOpen } = useModal();
  const { page, limit, handlePagination, handleLimit } = useTable();
  const [switchStatus, setSwitchStatus] = useState(false);

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Package Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      sortIcon: () => <SortIcon />,
    },

    {
      title: "Subscription Plan",
      dataIndex: "plan",
    },
    {
      title: "Price (BDT)",
      dataIndex: "price",
    },
    {
      title: "Users Qty",
      dataIndex: "qty",
    },
    {
      title: "Features",
      dataIndex: "features",
      align: "center",
      render: (val) => (
        <div
          className="max-w-[64px] cursor-pointer flex items-center gap-x-[6px] bg-[#F0F3F9] rounded-md px-[6px] py-[2px]"
          onClick={() =>
            handleOpen({
              type: "VIEW",
              data: val,
            })
          }
        >
          <ListIcon /> <p>{val}</p>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 116,
      render: (value) => (
        <div className="flex gap-x-1">
          <Switch size="small" onChange={(val) => setSwitchStatus(val)} />
          <span className="">{switchStatus ? "Active" : "Inactive"}</span>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Button
            className="action-button"
            size="small"
            icon={<EditIcon />}
            // onClick={() =>
            //   handleOpen({
            //     type: "UPDATE",
            //     data: val,
            //   })
            // }
          />

          <Link to={`/admin/customers/view/${val?.id}`}>
            <Button
              className="action-button"
              size="small"
              icon={<ViewIcon />}
            />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <SidebarLayout title="Package Management">
      <CustomTable
        loading={false}
        limit={limit}
        page={page}
        columns={columns}
        total={120} // Update total as per the data
        dataSource={data}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search"
              style={{ width: 220 }}
            />

            <Button
              type="primary"
              className="middle-button"
              icon={<AddIcon />}
              onClick={() =>
                handleOpen({
                  type: "ADD",
                })
              }
            >
              Add New Packages
            </Button>
          </>
        }
      />

      {/* Modal */}
      {open.type === "ADD" && (
        <ManagePackage
          open={open.open}
          data={open?.data}
          type={open?.type}
          handleClose={handleClose}
        />
      )}

      {open.type === "VIEW" && (
        <FeaturesView
          open={open.open}
          data={open?.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}

interface DataType {
  title: string;
  plan: string;
  price: string;
  qty: string;
  features: string;
  status: string;
  id: string;
}

const data: DataType[] = [
  {
    title: "Package-1",
    plan: "Trial 15 Day",
    price: "65",
    qty: "5",
    features: "View",
    status: "Active",
    id: "1",
  },
  {
    title: "Package-1",
    plan: "Trial 15 Day",
    price: "65",
    qty: "5",
    features: "View",
    status: "Inactive",
    id: "2",
  },
  {
    title: "Package-1",
    plan: "Trial 15 Day",
    price: "65",
    qty: "5",
    features: "View",
    status: "Active",
    id: "3",
  },
];
